import { comments } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            吃瓜群众都在说
          </h2>
          <p className="text-sm text-foreground-500 mt-3">来看看其他瓜友的真实评价</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {comments.map((item) => (
            <div
              key={item.id}
              className="bg-background-100/80 rounded-xl p-5 border border-background-200/60 hover:border-primary-200/60 transition-colors"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-300 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 truncate">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
              <div className="flex items-center gap-3 mt-4 pt-3 border-t border-background-200/60">
                <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-thumb-up-line text-sm"></i>
                  <span>{item.likes}</span>
                </button>
                <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-chat-1-line text-sm"></i>
                  <span>回复</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}